const mutations = {
    SET_ERROR_LINES(state, payload) {
        state.error = payload;
    }
};

export default mutations;
